<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title">
          Реквизиты документа, подтверждающие полномочия представителя
        </div>
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="v.name.$model"
          :errorMessages="getValidationErrorText(v.name)"
          label="Наименование документа"
          outlined
        />
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="v.authorityInfo.$model"
          :errorMessages="getValidationErrorText(v.authorityInfo)"
          label="Полномочия представителя"
          outlined
          disabled
        />
      </v-col>

      <v-col cols="6">
        <DateFieldCustom
          label="Дата выдачи доверенности"
          :value="v.issueDate.$model"
          @change="v.issueDate.$model = $event"
          :errorMessage="v.issueDate"
          :max="new Date().toISOString()"
          disabled
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="v.issuer.$model"
          :errorMessages="getValidationErrorText(v.issuer)"
          label="Кем выдан"
          outlined
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="v.issueNumber.$model"
          :errorMessages="getValidationErrorText(v.issueNumber)"
          label="Единый регистрационный номер доверенности"
          outlined
          disabled
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="v.regNumber.$model"
          :errorMessages="getValidationErrorText(v.regNumber)"
          label="Реестровый номер доверенности"
          outlined
          disabled
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getValidationErrorText, TRAILING_AND_LEADING_SPACES } from '@/utils/validate';
import DateFieldCustom from '@/components/base/DateFieldCustom';

export const mrpaBaseAuthorityValidation = {
  name: {
    TRAILING_AND_LEADING_SPACES,
  },
  authorityInfo: {},
  issueDate: {},
  issuer: {
    TRAILING_AND_LEADING_SPACES,
  },
  issueNumber: {},
  regNumber: {
    TRAILING_AND_LEADING_SPACES,
  },
  mrpIssuerInn: {},
};

export const mrpaBaseAuthorityModel = {
  name: '',
  authorityInfo: '',
  issueDate: '',
  issuer: '',
  issueNumber: '',
  regNumber: '',
  mrpIssuerInn: '',
};

export default {
  name: 'MrpaBaseAuthority',
  components: {
    DateFieldCustom,
  },
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    getValidationErrorText,
  }),
};
</script>
